import type { Transaction } from "@rocicorp/zero";
import { zql } from "./generatedDrizzleSchema";
import { insertRows } from "./insertRows";

export async function refreshConnectorUsages(
  tx: Transaction,
  commitId: string
) {
  const branches = await tx.run(
    zql.workflowBranches.where("headCommitId", commitId)
  );
  if (branches.length === 0) return;
  const stepsByConnector = [
    ...Map.groupBy(
      await tx.run(
        zql.connectedAppUsages
          .where("type", "commit_step")
          .where("refId", commitId)
      ),
      (use) => use.connectedAppId
    ),
  ];
  for (const branch of branches) {
    for (const use of await tx.run(
      zql.connectorUsages.where("branchId", branch.id)
    ))
      await tx.mutate.connectorUsages.delete(use);
    await insertRows(
      tx,
      "connectorUsages",
      stepsByConnector.map(([connectorId, uses]) => ({
        tenantId: branch.tenantId,
        connectorId,
        branchId: branch.id,
        workflowId: branch.workflowId,
        stepDirs: uses.map((use) => use.subKey).sort(),
      }))
    );
  }
}
